import { Branch, BranchProgressState } from '../../models/branch.model'

export const FAILURE_STATUS = [
  'UPLOAD_FAILED',
] as const satisfies BranchProgressState[]
export type FailureStatus = (typeof FAILURE_STATUS)[number]

export const PROCESS_STATUS = [
  'UPLOAD_VALIDATED',
  'UPLOAD_PROCESSED',
  'ADDRESS_VALIDATION_DUPLICATE_CHECKED',
  'ADDRESS_VALIDATION_ADDRESS_CHECKED',
] as const satisfies BranchProgressState[]
export type ProcessStatus = (typeof PROCESS_STATUS)[number]

export const END_STATUS = [
  ...FAILURE_STATUS,
  'ADDRESS_VALIDATION_ADDRESS_CHECKED',
  'ADDRESS_VALIDATION_COMPLETED',
] as const satisfies BranchProgressState[]
export type EndStatus = (typeof END_STATUS)[number]

export type MetaDataModel = Partial<Pick<Branch, 'type' | 'mevId' | 'note'>> & {
  fundingCode?: string // the value instead of key is used here
  source?: string // the value instead of key is used here
  reason?: string // the value instead of key is used here
}

export enum Step {
  metadata = 0,
  upload = 1,
  progress = 2,
}
